import { connect } from 'react-redux';
import { toggleContractPreview } from 'pap/ducks/workflow';
import Contract from 'pap/components/common/input_fields/contract';

export default connect(() => ({}), {
  onToggle: toggleContractPreview
})(Contract);
